import {SERVER_URLS} from '@env/baseURL';
import * as packageJson from 'package.json';

const packageVersion = JSON.stringify(packageJson);

export const environment = {
  apiPort: 0,
  apiUrl: SERVER_URLS.pqNet2ApiDev,
  appName: 'ProquifaNet 2',
  appVersion: JSON.parse(packageVersion)?.version,
  environmentServerName: 'cloudflare-dev-r9',
  i18nPrefix: '',
  identityPort: 9001,
  identityUrl: SERVER_URLS.pqNet2IdentityDev,
  production: false,
};
